export {
    CreateMiniGameInputSchema,
    UpdateMiniGameInputSchema,
    DeleteMiniGameInputSchema,
    GetMiniGameByIdInputSchema,
    UpdateMiniGameSetInputSchema,
} from './schemas';

export type {
    CreateMiniGameInput,
    UpdateMiniGameInput,
    DeleteMiniGameInput,
    GetMiniGameByIdInput,
    UpdateMiniGameSetInput,
} from './types';
